/* unplugin-vue-components disabled */import { render } from "./UserLocation.vue?vue&type=template&id=37e3b0a6&scoped=true"
import script from "./UserLocation.vue?vue&type=script&lang=js"
export * from "./UserLocation.vue?vue&type=script&lang=js"

import "./UserLocation.vue?vue&type=style&index=0&id=37e3b0a6&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/txgynew-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37e3b0a6"]])

export default __exports__